import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  ViewChild,
  ElementRef,
  Directive,
  HostListener,
} from '@angular/core';
import { ContentManagementService } from '../../../Services/content-management/content-management.service';
import { AnswerChoiceModel } from 'src/app/Models/AnswerChoiceModel';
import { QuestionStatusModel } from 'src/app/Models/QuestionStatusById';
import { FormBuilder, FormGroup } from '@angular/forms';
import { VAddAnswerChoice } from 'src/app/Validators/Validators';
import { ToastrService } from 'ngx-toastr';
import { VStudyMaterial } from 'src/app/Validators/Validators';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import {
  HttpClient,
  HttpRequest,
  HttpEvent,
  HttpHeaders,
} from '@angular/common/http';
//import { TokenStorageService } from 'src/app/_services/token-storage.service';
import { StudyMaterialModel } from 'src/app/Models/StudyMaterial';
//import { ApiheadersService } from 'src/app/service/apiheaders.service';
import { ChangeDetectorRef } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-content-preview',
  templateUrl: './content-preview.component.html',
  styleUrls: ['./content-preview.component.css'],
})
// @Directive({
//   selector: '[app-content-preview]'
// })
export class ContentPreviewComponent implements OnInit {
  @Input() subjectById: any;
  @Input() studymateriallist: any;
  @Input() ScreenName1: string;
  @Input() StudymaterialFormvalue: any;
  @Output() ClickContentstatus: EventEmitter<any> = new EventEmitter<any>();
  @Output() returnclosebutton: EventEmitter<any> = new EventEmitter<any>();

  //pdfSrc:any = "https://perfectlearningapp.azurewebsites.net//UploadFiles/History_Post_Mauryan_Period_The_Gupta_Dynasty_Study_Unit_1_ENG_Perfect_Learning_Screen_Requirements.pdf";
  pdfSrc1 = 'https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf';
  Filename: string;
  FileType: any;
  urlSafe: any;
  urlSafe1: SafeUrl;

  prev_url: any;
  assetURL: string;
  pdfSrc: string;
  File_Name: string;

  // isEmpty:boolean=true;
  // videoList:any=[];
  InsertStudyMaterial: StudyMaterialModel;
  AddPreviewform: FormGroup;

  // @HostListener('contextmenu', ['$event'])
  // onRightClick(event) {
  //   event.preventDefault();
  // }

  // @HostListener('contextmenu', ['$event'])

  // onRightClick(event) {    event.preventDefault();  }

  // viewer = 'google';

  // selectedType = 'docx';

  //DemoDoc="http://www.africau.edu/images/default/sample.pdf"

  constructor(
    private cdr: ChangeDetectorRef,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    public service: ContentManagementService,
    private fb: FormBuilder,
    private toastr: ToastrService
  ) {}

  InitializeForm() {
    this.AddPreviewform = this.fb.group({
      Description_Text: ['', VStudyMaterial],
    });
  }

  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }
  ngOnInit() {
    this.InitializeForm();
    this.getBreadcrumbDetails();
    this.Descriptioncount();

    //this.loadAllVideo();
    console.log(this.studymateriallist, 'studymaterial');
    console.log(this.subjectById, 'subjectById');
    this.Filename = this.studymateriallist.File_Location_Name;
    this.FileType = this.studymateriallist.File_Type_Name;
    this.File_Name = this.studymateriallist.File_Name;

    if (this.FileType == 'Video') {
      if (this.Filename != null && this.Filename != '') {
        //this.urlSafe= this.Filename;
        if (this.File_Name == 'External URL') {
          this.urlSafe1 = this.sanitizer.bypassSecurityTrustResourceUrl(
            this.Filename
          );
                  this.urlSafe =
          new URL(environment.apiBaseUrl).origin +
          this.studymateriallist.File_Location_Name +
          '/' +
          (this.studymateriallist.File_Name_In_Server || '');
          //this.urlSafe= this.Filename;
          console.log(this.urlSafe1, 'urlSafe1');
        } else {
          this.urlSafe1 = this.sanitizer.bypassSecurityTrustResourceUrl(
            this.Filename
          );
          //this.urlSafe= this.Filename;
        }
      }
    } else {
      if (this.Filename != null && this.Filename != '') {

        const url =
          new URL(environment.apiBaseUrl).origin +
          this.studymateriallist.File_Location_Name +
          '/' +
          (this.studymateriallist.File_Name || '').split('#')[1];

        this.urlSafe =
          new URL(environment.apiBaseUrl).origin +
          this.studymateriallist.File_Location_Name +
          '/' +
          (this.studymateriallist.File_Name_In_Server || '');
        //this.Filename;
        console.log(this.urlSafe, 'PDFURL');

        //this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.Filename);
        //this.pdfSrc=this.Filename;
      }
    }
    // +"?page=hsn#toolbar=0"
    //this.assetURL=this.Filename;
    //this.assetURL="https://perfectlearningapp.azurewebsites.net//UploadFiles/Chemistry_Periodic_Table_of_Elements_Modern_Periodic_Table_Basics_Study_Unit_3_test_1_ENG_file_example_MP4_640_3MG.mp4";
    //this.assetURL =  "https://perfectlearningapp.azurewebsites.net/"+this.studymateriallist.Study_Material_Id;
  }

  //   _base64ToArrayBuffer(base64:any) {
  //     const binary_string = window.atob(base64);
  //     const len = binary_string.length;
  //     const bytes = new Uint8Array(len);
  //     for (let i = 0; i < len; i++) {
  //         bytes[i] = binary_string.charCodeAt(i);
  //     }
  //     return bytes.buffer;
  // }

  videoPlayer: HTMLVideoElement;

  @ViewChild('videoPlayer') videoplayer: ElementRef;

  toggleVideo() {
    this.videoplayer.nativeElement.play();
  }

  Breadcrumblist: any;
  Breadcrumb: string;
  getBreadcrumbDetails() {
    //  this.service.getBreadcrumbDetails({ 'ID': this.subjectById.Subject_Id }).subscribe((i: any) => {
    //    this.Breadcrumblist = i;
    this.service
      .getBreadcrumb({
        ID: this.studymateriallist.Study_Unit_Id,
        Screenname: 'CONTENT_MANAGEMENT',
      })
      .subscribe(
        (i: any) => {
          this.Breadcrumblist = i;
          this.Breadcrumb = this.Breadcrumblist.Data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  AddSubmitReview(data: any) {
    let list = {
      Content_status: data,
      Content: this.studymateriallist,
    };
    this.ClickContentstatus.emit(list);
  }

  Descriptionvaluelength: any;
  DescriptionMaxlength: any;
  Descriptioncount() {
    this.DescriptionMaxlength = 4000;
    if (
      this.AddPreviewform.controls.Description_Text.value != '' &&
      this.AddPreviewform.controls.Description_Text.value != null
    ) {
      if (this.AddPreviewform.controls.Description_Text.value.length > 0) {
        this.Descriptionvaluelength =
          this.AddPreviewform.controls.Description_Text.value.length;
      } else {
        this.Descriptionvaluelength = 0;
      }
    } else {
      this.Descriptionvaluelength = 0;
    }
  }

  clkclosebutton(data: any) {
    this.returnclosebutton.emit(data);
  }

  // }

  zoom_scale: number = 0.9;
  Rotate: number = 0;
  zoom(key: Number): void {
    let zoom: Number = 0;
    if (key == 1) {
      zoom = Number(this.zoom_scale) + Number(0.1);
    }
    if (key == 0) {
      zoom = Number(this.zoom_scale) - Number(0.1);
    }
    if (zoom > 0 || zoom < 1.5) {
      this.zoom_scale = Number(zoom);
    }
  }
  Rotation() {
    if (Number(this.Rotate) == 0) {
      this.Rotate = 90;
    } else if (Number(this.Rotate) == 90) {
      this.Rotate = 180;
    } else if (Number(this.Rotate) == 180) {
      this.Rotate = 0;
    }
  }
}
